/**
 * Datums-Bereichsfilter (Von/Bis) der Spaltenfilter (Auftrag "Bestellboard-Filter datentypgerecht
 * bauen", 2026-09-01) - NEUBAU ohne Bestandsvorbild. Ersetzt den bisherigen Exakttreffer fuer die
 * vier Datumsspalten (`due`/`etdPi`/`etd`/`eta`, `lib/orderList.ts#ORDER_LIST_DATE_KEYS`).
 *
 * Beide Enden sind unabhaengig optional - ein gesetztes "Von" ohne "Bis" filtert nach unten offen,
 * und umgekehrt (siehe `orderListZeilePasstFilter`). Die Kurzwahl ("überfällig", "nächste 7/30 Tage")
 * aus dem Auftragsbrief ist bewusst NICHT gebaut - dort ausdruecklich als Nice-to-have markiert.
 *
 * NACHBESSERUNG W1/W2 (Pruefung): der Knopf "Nur ohne Wert" bildet den Zustand nach, den das alte
 * `<select>` ueber die Facettenoption "Ohne Wert" (`__EMPTY__`) anbot und den Von/Bis allein nicht
 * ausdruecken kann - ohne ihn gaebe es in der neuen Oberflaeche KEINEN Weg mehr, gezielt nach Zeilen
 * OHNE Datum zu filtern (nicht nur der alte Tieflink war betroffen, siehe `lib/orderList.ts#
 * Bereichsfilter`). Exklusiv: aktiviert, sperrt er die Von/Bis-Felder (angezeigt, aber unbedienbar,
 * ihr Inhalt bleibt beim Wiederabwaehlen erhalten statt geloescht zu werden).
 *
 * NACHBESSERUNG (Pruefer-Befund "Wichtig" 2, Historie-Tabelle, 2026-09-06): `ohneWertVerstecken`
 * blendet genau diese Checkbox aus - fuer Aufrufer, deren Spalte NIE einen leeren Wert kennen kann
 * (die Zeitpunkt-Spalte von `HistoryTab.tsx`: `ts` ist nach dem API-Typ nie leer, ein Klick auf "Nur
 * ohne Wert" haette dort zuverlaessig JEDE Zeile ausgeblendet, siehe `lib/historyList.ts
 * #historyZeilePasstFilter`). Optional, Default `false` - der Board-Aufrufer (`Spaltenkopf.tsx`)
 * uebergibt das Prop nicht und bleibt dadurch unveraendert.
 */
import type { Bereichsfilter } from "../../../lib/orderList.ts";

export interface DatumsBereichFilterProps {
  label: string;
  bereich: Bereichsfilter;
  onAendern: (bereich: Bereichsfilter) => void;
  ohneWertVerstecken?: boolean;
}

export function DatumsBereichFilter({
  label,
  bereich,
  onAendern,
  ohneWertVerstecken = false,
}: DatumsBereichFilterProps) {
  const ohneWert = Boolean(bereich.ohneWert);
  return (
    <div className="spaltenfilter-bereich-block">
      <div className="spaltenfilter-bereich">
        <label className="spaltenfilter-bereich-feld">
          <span>Von</span>
          <input
            type="date"
            aria-label={`${label} von`}
            value={bereich.von ?? ""}
            disabled={ohneWert}
            onChange={(ereignis) => onAendern({ ...bereich, von: ereignis.target.value })}
          />
        </label>
        <label className="spaltenfilter-bereich-feld">
          <span>Bis</span>
          <input
            type="date"
            aria-label={`${label} bis`}
            value={bereich.bis ?? ""}
            disabled={ohneWert}
            onChange={(ereignis) => onAendern({ ...bereich, bis: ereignis.target.value })}
          />
        </label>
      </div>
      {ohneWertVerstecken ? null : (
        <label className="spaltenfilter-option spaltenfilter-ohne-wert">
          <input
            type="checkbox"
            aria-label={`${label}: nur ohne Wert`}
            checked={ohneWert}
            onChange={(ereignis) => onAendern({ ...bereich, ohneWert: ereignis.target.checked })}
          />
          <span>Nur ohne Wert</span>
        </label>
      )}
    </div>
  );
}
